import { render, staticRenderFns } from "./dialogs.vue?vue&type=template&id=75d8b7eb&scoped=true&"
import script from "./dialogs.vue?vue&type=script&lang=js&"
export * from "./dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d8b7eb",
  null
  
)

export default component.exports